import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, inject, OnInit, Input } from '@angular/core';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NgFor, NgIf, CommonModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  @Input() parentNodeName: string | null = null;
  
  router:Router = inject(Router);
  menuItems: any;
  ifHasItems: boolean = false;

  ngOnInit(): void {
    if(this.parentNodeName) {
      this.buildMenu();
    }
  }

  private buildMenu() {
    // Initial parent name
    const parentMainRoute = this.router.config.find(r => r.path === this.parentNodeName);
    console.log('parentMainRoute', parentMainRoute)
    // Sub parent path
    const subParentRouteName = parentMainRoute?.children?.find(route => route.path !== '');
    // Sub parent path name
    const subPathName = subParentRouteName?.path;
    let items = [];
    // If the sub parent has childrens...
    if(subParentRouteName?.children) {
      this.ifHasItems = true;
      const overviewRoute = parentMainRoute?.children?.find(r => r.path === subPathName);
      const overviewChildren = overviewRoute?.children ?? [];
      const  mainPath = {
        path: `/${this.parentNodeName}/${subPathName}`,
        title: subPathName
      };      
      items = overviewChildren
      .filter(child => child.path !== '')
      .map((child: any) => ({        
          title: child.data?.label,
          path: `/${this.parentNodeName}/${subPathName}/${child.path}`        
        }));
        this.menuItems = { items: [...items], mainPath, hasParents: true };
    } else {
      items = [{
        title: subParentRouteName?.data?.['label'],
        path: `/${this.parentNodeName}/${subPathName}`
      }];
      this.menuItems = { items: [...items], hasParents: false };
      console.log('menuItems', this.menuItems)
    }
  }


}
